import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'

export interface BalanceOfdebtState {
  balanceOfdebtList?: any
  balanceOfdebtDetail?: any
}

const initialState: BalanceOfdebtState = {
  balanceOfdebtList: {},
  balanceOfdebtDetail: {},
}

export const balanceOfdebtDucks = createSlice({
  name: 'balanceOfdebt',
  initialState,
  reducers: {
   
    getListBalanceOfdebt: (state: RootState, action: PayloadAction<any>) => {
      state.balanceOfdebtList = { loading: true, queryStr: action.payload }
    },
    getListBalanceOfdebtSuccess: (state, action: PayloadAction<any>) => {
      state.balanceOfdebtList = { loading: false, ...action.payload }
    },
    getListBalanceOfdebtFail: (state, action: PayloadAction<any>) => {
      state.balanceOfdebtList = { loading: false, ...action.payload }
    },
    
    getDetailBalanceOfdebt: (state: RootState, action: PayloadAction<any>) => {
      state.balanceOfdebtDetail = { loading: true, id: action.payload }
    },
    getDetailBalanceOfdebtSuccess: (state, action: PayloadAction<any>) => {
      state.balanceOfdebtDetail = { loading: false, ...action.payload }
    },
    getDetailBalanceOfdebtFail: (state, action: PayloadAction<any>) => {
      state.balanceOfdebtDetail = { loading: false, ...action.payload }
    },
    
  },
})

// Action creators are generated for each case reducer function
export const {
  getListBalanceOfdebt,
  getListBalanceOfdebtSuccess,
  getListBalanceOfdebtFail,
  getDetailBalanceOfdebt,
  getDetailBalanceOfdebtSuccess,
  getDetailBalanceOfdebtFail,
} = balanceOfdebtDucks.actions

export default balanceOfdebtDucks.reducer
